import { cn } from '@bem-react/classname';

export const cnTabsMenu = cn('TabsMenu');
